import { cloneDeep, isEqual } from 'lodash';
import BaseDropdown from '../../base/dropdowns/dropdown';

import '../../base/dropdowns/dropdown.scss';

class WinningDropdown extends BaseDropdown {
  constructor(props) {
    super(props);

    this.type = 'options';
    this.identifierField = 'name';
    this.hasSearch = false;

    this.state = {
      options: this.props.items,
      opened: false,
      focusIndex: null,
      label: this.getLabel(this.props.items),
    };
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.items, this.props.items)) {
      const options = this.getSelectedOptions(this.props.items);
      this.setState({
        options,
        label: this.getLabel(this.props.items),
      });
    }
  }

  update() {
    const options = this.getSelectedOptions(this.state.options);
    this.props.updateOptions(options);
  }

  resetColumns(selectedState) {
    // Create deep copy to prevent mutating state object directly
    let options = cloneDeep(this.state.options);
    options = options
      .filter(option => !option.hidden)
      .map(option => {
        option.selected = selectedState;
        return option;
      });
    this.setState({ options });
  }

  getSelectedOptions(options) {
    let newOptions = cloneDeep(options);
    // If no options selected, select all options instead
    if (newOptions && !newOptions.filter(option => option.selected).length) {
      newOptions = newOptions.map(option => {
        option.selected = true;
        return option;
      });
    }

    return newOptions;
  }

  getLabel(options) {
    let label;
    const numSelected = options.reduce((agg, option) => {
      if (option.selected) agg++;
      return agg;
    }, 0);

    if (numSelected === 0 || numSelected === 2) {
      label = 'All Articles';
    } else {
      label = options.find(option => option.selected).label;
    }

    return label;
  }
}

export default WinningDropdown;
